export enum ApplicationEnvironment {
  PRODUCTION = 'production',
  DEVELOP = 'develop',
}

export enum PWAType {
  MegaWhales,
  Alpha
}